import {http} from "../utils/http";
import {Response} from '../types/resp';
import { PrefixResult } from '../types/prefix';
export const prefix = {
	permission: async () => {
		return http.get<Response<PrefixResult>>('/prefix/permission')
	},
}
